/* Recently viewed — localStorage-backed list of product handles.
   Exposed as window.TPHRecent. */
(() => {
  const KEY = 'tph:recent:v1';
  const MAX = 10;

  function load() {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch { return []; }
  }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {} }

  window.TPHRecent = {
    push(handle) {
      if (!handle) return;
      const list = load().filter((h) => h !== handle);
      list.unshift(handle);
      save(list.slice(0, MAX));
    },
    list: (excludeHandle = null) => load().filter((h) => h !== excludeHandle),
    clear: () => save([]),
  };
})();
